import { isIOS, isAndroid } from './utils'

export const isProduction = process.env.REACT_APP_ENV === 'prd'

export const GA4MeasurementID = isProduction ? 'G-WTG9JVG9JF' : 'G-KEYTFGZ9KK'

export const aifianDynamicLink = isProduction
  ? 'https://aifian.page.link/4R1F'
  : 'https://aifianstg.page.link/v2EF'

export const DOMAIN = 'https://api.aifian.com'

export const slashURL = isProduction
  ? 'https://www.aifian.com/slash.html'
  : 'https://www-dev.aifian.com/slash.html'
export const slashTermsURL = isProduction
  ? 'https://www.aifian.com/resource_terms.html'
  : 'https://www-dev.aifian.com/resource_terms.html'

export const orderConfirmationURL = isProduction
  ? 'https://www.celex.vip/subscription/success'
  : 'https://www-dev.celex.vip/subscription/success'

export const TAPPAY = {
  SDK_URL: 'https://js.tappaysdk.com/tpdirect/v5.1.0',
  ENV: isProduction ? 'production' : 'sandbox',
  TERMS:
    '本公司採用喬睿科技TapPay金流交易系統，消費者刷卡時直接在銀行端系統中交易，本公司不會留下您的信用卡資料，以保障你的權益，資料傳輸過程採用嚴密的SSL 2048bit加密技術保護。',
}

export const facebookGroupPageURL =
  'https://www.facebook.com/groups/266672091206267/'
export const lineCustomerServiceURL = 'https://line.me/R/ti/p/@mmc8796z'

export const appStoreDownloadURL =
  'https://itunes.apple.com/tw/app/aifian/id1447838651'
export const googlePlayDownloadURL =
  'https://play.google.com/store/apps/details?id=com.adenovo.aifian'
export const aifianDownloadURL = 'https://www.aifian.com/app.html'

export const forgetPasswordURL = `https://service${
  isProduction ? '' : '-dev'
}.aifian.com/forget-password`

export function getDownloadURL(): string {
  if (isIOS) return appStoreDownloadURL
  if (isAndroid) return googlePlayDownloadURL
  return aifianDownloadURL
}

export const PRODUCT_TYPE = 'slash'

export const formLimits = {
  title: {
    limit: 30,
    errorMessage: '開團名稱限 30 中文字',
  },
  price: {
    minLimit: 10,
    minErrorMessage: '開團金額不可小於 10 元',
  },
  qty: {
    default: '沒有限制',
    errorFormMessage: '請輸入大於1的整數',
  },
  deadline: {
    errorMessage: '日期格式錯誤',
  },
  message: {
    limit: 150,
    default: '感謝你的購買 😁',
    errorMessage: '訊息字數不可多於 150 個中文字',
  },
}

export const slashInactiveMessages = {
  buyer:
    'aifian Slash 刷卡額度已滿，目前無法付款。aifian 正在積極的處理中，如有任何消息會公佈在臉書社團裡，非常謝謝你的體諒與支持！',
  seller:
    'aifian Slash 刷卡額度已滿，目前無法開團。aifian 正在積極的處理中，如有任何消息會公佈在臉書社團裡，非常謝謝你的體諒與支持！',
}

export const appDynamicLink = `https://aifian${
  isProduction ? '' : 'stg'
}.page.link/app`
